import companies from './companies.data.json';

export default companies;

export const getCompanyById = id => {
  return [...companies].find(company => company.id === id);
};

export const getCompanyByName = name => {
  return [...companies].find(company => company.name === name)
};
